import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import logo from "../../logo.svg";
import styles from "./Header.module.css";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

const Header = ({ activeMenu, setActiveMenu }) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const solutionsItems = [
    { id: 'Elohim',     name: 'Elohim',    description: t('header.reconhecimentoFacial'), visible: true,  route: '/Elohim'     },
    { id: 'Sanarix',    name: 'Sanarix',   description: t('header.gestaoCli'),            visible: true,  route: '/Sanarix'    },
    { id: 'Simao',      name: 'Simão',     description: t('header.assistenteVirtual'),    visible: false, route: '/Simao'      },
    { id: 'NotaFiscal', name: 'SteinNFe',  description: t('header.apiNotaFiscal'),        visible: true,  route: '/NotaFiscal' },
    { id: 'TIPresencial', name: 'T.I Presencial', description: t('header.tiPresencial'), visible: true, route: '/TIPresencial' },
  ];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownOpen && !event.target.closest(`.${styles['dropdown-container']}`)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [dropdownOpen]);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const navigate = useNavigate();

  const handleMenuClick = (id) => {
    setActiveMenu(id);
    setMenuOpen(false);
    setDropdownOpen(false);
    if (id === 'Inicio') {
      navigate("/");
    } else {
      navigate("/" + id);
    }
  };

  const handleDropdownClick = (item) => {
    setActiveMenu('NossasSolucoes');
    setMenuOpen(false);
    setDropdownOpen(false);
    navigate(item.route);
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.shrink : ""}`}>
      <div
        className={`${styles.logo} ${isScrolled ? styles.shrink : ""}`}
        onClick={() => handleMenuClick("Inicio")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleMenuClick("Inicio")}
        aria-label="Ir para o início"
      >
        <img
          src={logo}
          alt="Logo"
          className={`${styles['logo-icon']} ${isScrolled ? styles.shrink : ""}`}
        />
        <span className={`${styles['logo-text']} ${isScrolled ? styles.shrink : ""}`}>SteinSoft</span>
      </div>
      <div className={styles.spacer}></div>
      <button className={styles['menu-toggle']} onClick={toggleMenu} aria-label="Toggle Menu">
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>
      <nav className={`${styles['nav-menu']} ${menuOpen ? styles.open : ""} ${isScrolled ? styles.shrink : ""}`}>
        <ul>
          <li>
            <a href="/" onClick={() => handleMenuClick("Inicio")}
              className={`${styles['menu-link']} ${activeMenu === "Inicio" ? styles.active : ""}`}>
              {t('header.inicio')}
            </a>
          </li>
          <li>
            <a onClick={() => handleMenuClick("SobreNos")}
              className={`${styles['menu-link']} ${activeMenu === "SobreNos" ? styles.active : ""}`}>
              {t('header.sobreNos')}
            </a>
          </li>
          <li>
            <a onClick={() => handleMenuClick("Servicos")}
              className={`${styles['menu-link']} ${activeMenu === "Servicos" ? styles.active : ""}`}>
              {t('header.servicos')}
            </a>
          </li>
          <li>
            <a onClick={() => handleMenuClick("NossosValores")}
              className={`${styles['menu-link']} ${activeMenu === "NossosValores" ? styles.active : ""}`}>
              {t('header.nossosValores')}
            </a>
          </li>
          <li className={styles['dropdown-container']}>
            <div className={`${styles['dropdown-trigger']} ${activeMenu === "NossasSolucoes" ? styles.active : ""}`}>
              <a onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`${styles['menu-link']} ${activeMenu === "NossasSolucoes" ? styles.active : ""}`}>
                {t('header.nossasSolucoes')}
                <svg
                  className={`${styles['dropdown-arrow']} ${dropdownOpen ? styles.rotate : ''}`}
                  width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6z"/>
                </svg>
              </a>
              {dropdownOpen && (
                <div className={styles['dropdown-menu']}>
                  <div className={styles['dropdown-content']}>
                    {solutionsItems.filter(item => item.visible).map((item) => (
                      <a key={item.id} onClick={() => handleDropdownClick(item)} className={styles['dropdown-item']}>
                        <span className={styles['dropdown-item-name']}>{item.name}</span>
                        <span className={styles['dropdown-item-desc']}>{item.description}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </li>
          <li>
            <a onClick={() => handleMenuClick("SobreAEmpresa")}
              className={`${styles['menu-link']} ${activeMenu === "SobreAEmpresa" ? styles.active : ""}`}>
              {t('header.sobreAEmpresa')}
            </a>
          </li>
          <li>
            <a onClick={() => handleMenuClick("Contato")}
              className={`${styles['menu-link']} ${activeMenu === "Contato" ? styles.active : ""}`}>
              {t('header.contato')}
            </a>
          </li>
        </ul>
      </nav>
      <LanguageSwitcher />
    </header>
  );
};

export default Header;
